import TableHeader from './TableHeader';

export default TableHeader;
export * from './types';
export { TableHeader };
